exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "wage-advance-list .subtitle{font-family:Stag Sans;font-size:15px;line-height:1;text-align:justify;color:#666;margin:13px 0 30px}wage-advance-list wage-advance-card .wage-advance-card:last-child{border-bottom:1px solid #dddfe2}wage-advance-list .wage-advance-list-content.mobile label{font-size:16px}wage-advance-list .wage-advance-list-content.mobile .subtitle{font-size:13px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/features/wageAdvance/wageAdvanceList/wageAdvanceList.scss
// module id = 2128
// module chunks = 0